export const getOneIdentityModuleState = (state) => state.getIn(['modules', 'one-identity-root']);
export const getOneIdentityCoreState = (state) => getOneIdentityModuleState(state)?.get('core');
export const getOneIdentityCorrelationId = (state) => getOneIdentityCoreState(state)?.get('oneIdentityCorrelationId');
export const getActiveLocale = (state) => state.getIn(['intl', 'activeLocale']);
export const getLoginConfig = (state, loginConfig) => state.getIn(['config', loginConfig]);
export const getLoginUsApiDomainConfig = (state) => state.getIn(['config', 'loginUsApiDomain']);
export const getLogSuccess = (state) => state.getIn(['config', 'fetchLogging', 'one-identity-login']);
